import FormattedMessage from 'I18n/components/FormattedMessage';
import { SkeletonDiv } from '../../common/SkeletonDiv';
import I18n from 'I18n';
import { Text } from 'foundations-components/components/Text';
import PropertyInformationPopoverLink from './PropertyInformationPopoverLink';
import { jsx as _jsx } from "react/jsx-runtime";
export default function PropertyInformationPopoverUsedIn({
  usageCount,
  usagesLink,
  loading
}) {
  if (loading && typeof usageCount === 'undefined') {
    return /*#__PURE__*/_jsx(SkeletonDiv, {
      blockSize: "18px",
      inlineSize: "100px",
      "aria-label": I18n.text('customerDataFiltersUI.propertyInformationPopover.details.usedIn.loading')
    });
  }
  if (typeof usageCount === 'undefined') {
    return /*#__PURE__*/_jsx(Text, {
      use: "disabled",
      truncate: true,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFiltersUI.propertyInformationPopover.details.usedIn.unknown"
      })
    });
  } else if (usageCount === 0) {
    return /*#__PURE__*/_jsx(Text, {
      use: "disabled",
      truncate: true,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFiltersUI.propertyInformationPopover.details.usedIn.values.zeroPlaces"
      })
    });
  } else {
    // the property is used one or more times
    const message = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataFiltersUI.propertyInformationPopover.details.usedIn.values.pluralPlaces",
      options: {
        count: usageCount
      }
    });
    return typeof usagesLink === 'undefined' ? message : /*#__PURE__*/_jsx(PropertyInformationPopoverLink, {
      href: usagesLink,
      linkType: "usages",
      children: message
    });
  }
}